export default function FloatingWhatsApp() {
  return (
    <a
      href="https://wa.me/27660198386"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition hover:scale-110"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-8 h-8"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M20.52 3.48A11.78 11.78 0 0 0 12.03 0C5.4 0 .02 5.38.02 12c0 2.11.55 4.17 1.6 5.99L0 24l6.2-1.61A11.96 11.96 0 0 0 12.03 24C18.66 24 24 18.62 24 12c0-3.2-1.25-6.22-3.48-8.52zM12.03 21.8c-1.8 0-3.55-.48-5.08-1.39l-.36-.21-3.68.96.98-3.59-.23-.37A9.73 9.73 0 0 1 2.2 12c0-5.42 4.41-9.83 9.83-9.83 2.63 0 5.1 1.02 6.96 2.88A9.79 9.79 0 0 1 21.86 12c0 5.42-4.41 9.8-9.83 9.8z" />
      </svg>
    </a>
  );
}